import {
  ChatBubbleLeftRightIcon,
  QueueListIcon,
  UserGroupIcon,
} from "@heroicons/react/24/outline";
import { useLocation, useNavigate } from "react-router-dom";
import { SubmitButton } from "../shared/buttons/submit-button";
import { useUserDetails } from "../../hooks/useUserDetails";

export default function ChatNavigation() {
  const location = useLocation();
  const navigate = useNavigate();
  const { userDetails } = useUserDetails();
  const isAdmin = userDetails?.type === "admin";

  const isInGroupChat = location.pathname.startsWith("/group-chat");
  const isInAIChat = location.pathname === "/chat";
  const isInAdminAllChats = location.pathname.startsWith("/admin/all-chats");

  const handleSwitchToAI = () => {
    if (!isInAIChat) {
      navigate("/chat");
    }
  };

  const handleSwitchToGroup = () => {
    if (!isInGroupChat) {
      navigate("/group-chats");
    }
  };

  const handleSwitchToAdminChats = () => {
    if (!isInAdminAllChats) {
      navigate("/admin/all-chats");
    }
  };

  return (
    <div className="flex items-center gap-2 mb-4">
      <SubmitButton
        size="sm"
        color={isInAIChat ? "terracotta" : "beige"}
        onClick={handleSwitchToAI}
        icon={<ChatBubbleLeftRightIcon className="w-4 h-4" />}
        className="flex items-center gap-2"
      >
        AI Chat
      </SubmitButton>

      <SubmitButton
        size="sm"
        color={isInGroupChat ? "terracotta" : "beige"}
        onClick={handleSwitchToGroup}
        icon={<UserGroupIcon className="w-4 h-4" />}
        className="flex items-center gap-2"
      >
        Group Chat
      </SubmitButton>

      {isAdmin && (
        <SubmitButton
          size="sm"
          color={isInAdminAllChats ? "terracotta" : "beige"}
          onClick={handleSwitchToAdminChats}
          icon={<QueueListIcon className="w-4 h-4" />}
          className="flex items-center gap-2"
        >
          All Chats
        </SubmitButton>
      )}
    </div>
  );
}
